module.exports = __webpack_public_path__ + "img/T1B_rc_13.47c254be.png";